import React from "react"
import { compose, withProps, lifecycle } from "recompose"
import { withScriptjs } from "react-google-maps"
import {API_KEY} from '../../utils/constants';

const { StandaloneSearchBox } = require("react-google-maps/lib/components/places/StandaloneSearchBox");

export default compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&language=en&v=3.exp&libraries=geometry,drawing,places`,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `400px` }} />,
  }),
  lifecycle({
    componentWillMount() {
      const refs = {}

      this.setState({
        places: [],
        onSearchBoxMounted: ref => {
          refs.searchBox = ref;
        },
        onPlacesChanged: () => {
          const places = refs.searchBox.getPlaces();
          this.props.onPlacesChanged(places);

          this.setState({
            places,
          });
        },
      })
    },
  }),
  withScriptjs
)(props =>
  <div className='search-box' data-standalone-searchbox="">
    <StandaloneSearchBox
      ref={props.onSearchBoxMounted}
      bounds={props.bounds}
      onPlacesChanged={props.onPlacesChanged}
    >
      <input
        type="text"
        placeholder="Search address ..."
        className='search-box__input'
        value={props.addressName}
        onChange={props.onInputChange}
      />
    </StandaloneSearchBox>
  </div>
);
